import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button } from "@jhool-io/fe-components";
import MeetingRoom from "../components/MeetingRoom/MeetingRoom";
import { useFetchJitsiToken } from "../hooks/meeting.queries";
import { useFetchUserDetails } from "../../auth/hooks/auth.queries";
import ListState from "../../../components/ListState/ListState";
import { getClientDisplayName } from "../../../utils/helpers";

export default function MeetingPage() {
    const { sessionHistoryId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const { isLoading, error, isSuccess, data } = useFetchJitsiToken(
        sessionHistoryId || ""
    );

    const displayName = searchParams.get("display_name");

    const loggedInUser = useFetchUserDetails();

    const errorMessage = error?.response?.data?.message;
    const isExpiredError = errorMessage === "expired";

    return (
        <>
            {isLoading ? (
                <div
                    className="flex items-center justify-center h-[92vh]"
                    data-testid="loader"
                >
                    <span className="mid-loader" />
                </div>
            ) : null}
            {error && isExpiredError ? (
                <div className="min-h-screen flex items-center justify-center p-20">
                    <div className="flex flex-col items-center justify-center text-center w-[60rem] max-w-full">
                        <p className="font-semibold text-base leading-[2.2rem] uppercase text-primary mb-12">
                            Patient Portal by Mantle
                        </p>
                        <h3 className="text-24 font-normal mb-10">
                            Session expired
                        </h3>
                        <p className="font-semibold text-sm leading-6">
                            This session has expired. Please click the button
                            below to return to the dashboard and view your
                            upcoming sessions.
                        </p>

                        <Button
                            type="button"
                            size="small"
                            onClick={() => navigate("/")}
                            className="mt-12"
                        >
                            Go back
                        </Button>
                    </div>
                </div>
            ) : null}
            {error && !isExpiredError ? (
                <div className="h-full text-sm font-medium flex items-center justify-center">
                    <ListState
                        isError
                        errorMsg={
                            errorMessage ||
                            "Could not load meeting at this time"
                        }
                        stateHelperText="Please contact support for assistance"
                        context="general"
                        cardClass="h-[92vh]"
                    />
                </div>
            ) : null}
            {isSuccess ? (
                <MeetingRoom
                    jitsiToken={data.data.token}
                    sessionHistoryId={sessionHistoryId || ""}
                    email={loggedInUser?.data?.data?.email ?? ""}
                    clientName={
                        displayName ||
                        getClientDisplayName(
                            loggedInUser?.data?.data?.preferred_name,
                            loggedInUser?.data?.data?.first_name
                        )
                    }
                    userId={loggedInUser?.data?.data?.user_id ?? ""}
                />
            ) : null}
        </>
    );
}
